// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CpuAndLoadAvgQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type CpuAndLoadAvgQuery = {
  __typename?: "GraphqlQuery";
  getSystemStats?: {
    __typename?: "SystemStatsSeries";
    id: string;
    cpuIowait?: Array<Array<number | null> | null> | null;
    cpuUser?: Array<Array<number | null> | null> | null;
    cpuSystem?: Array<Array<number | null> | null> | null;
    cpuIrq?: Array<Array<number | null> | null> | null;
    cpuSteal?: Array<Array<number | null> | null> | null;
    cpuIdle?: Array<Array<number | null> | null> | null;
    numCores?: Array<Array<number | null> | null> | null;
    loadAvg1min?: Array<Array<number | null> | null> | null;
    loadAvg5min?: Array<Array<number | null> | null> | null;
    loadAvg15min?: Array<Array<number | null> | null> | null;
  } | null;
};

export type CpuAndLoadAvgCpuUtilizationOnlyQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type CpuAndLoadAvgCpuUtilizationOnlyQuery = {
  __typename?: "GraphqlQuery";
  getSystemStats?: {
    __typename?: "SystemStatsSeries";
    id: string;
    cpuUtilization?: Array<Array<number | null> | null> | null;
  } | null;
};

export type CpuAndLoadAvgLoadAvgOnlyQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type CpuAndLoadAvgLoadAvgOnlyQuery = {
  __typename?: "GraphqlQuery";
  getSystemStats?: {
    __typename?: "SystemStatsSeries";
    id: string;
    loadAvg1min?: Array<Array<number | null> | null> | null;
    loadAvg5min?: Array<Array<number | null> | null> | null;
    loadAvg15min?: Array<Array<number | null> | null> | null;
  } | null;
};

export const CpuAndLoadAvgDocument = gql`
  query CPUAndLoadAvg($serverId: ID!, $startTs: Int!, $endTs: Int!) {
    getSystemStats(serverId: $serverId, startTs: $startTs, endTs: $endTs) {
      id
      cpuIowait
      cpuUser
      cpuSystem
      cpuIrq
      cpuSteal
      cpuIdle
      numCores
      loadAvg1min
      loadAvg5min
      loadAvg15min
    }
  }
`;

/**
 * __useCpuAndLoadAvgQuery__
 *
 * To run a query within a React component, call `useCpuAndLoadAvgQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpuAndLoadAvgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpuAndLoadAvgQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useCpuAndLoadAvgQuery(
  baseOptions: Apollo.QueryHookOptions<
    CpuAndLoadAvgQuery,
    CpuAndLoadAvgQueryVariables
  > &
    (
      | { variables: CpuAndLoadAvgQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CpuAndLoadAvgQuery, CpuAndLoadAvgQueryVariables>(
    CpuAndLoadAvgDocument,
    options,
  );
}
export function useCpuAndLoadAvgLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CpuAndLoadAvgQuery,
    CpuAndLoadAvgQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CpuAndLoadAvgQuery, CpuAndLoadAvgQueryVariables>(
    CpuAndLoadAvgDocument,
    options,
  );
}
// @ts-ignore
export function useCpuAndLoadAvgSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CpuAndLoadAvgQuery,
    CpuAndLoadAvgQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CpuAndLoadAvgQuery,
  CpuAndLoadAvgQueryVariables
>;
export function useCpuAndLoadAvgSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CpuAndLoadAvgQuery,
        CpuAndLoadAvgQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CpuAndLoadAvgQuery | undefined,
  CpuAndLoadAvgQueryVariables
>;
export function useCpuAndLoadAvgSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CpuAndLoadAvgQuery,
        CpuAndLoadAvgQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CpuAndLoadAvgQuery,
    CpuAndLoadAvgQueryVariables
  >(CpuAndLoadAvgDocument, options);
}
export type CpuAndLoadAvgQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgQuery
>;
export type CpuAndLoadAvgLazyQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgLazyQuery
>;
export type CpuAndLoadAvgSuspenseQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgSuspenseQuery
>;
export type CpuAndLoadAvgQueryResult = Apollo.QueryResult<
  CpuAndLoadAvgQuery,
  CpuAndLoadAvgQueryVariables
>;
export const CpuAndLoadAvgCpuUtilizationOnlyDocument = gql`
  query CPUAndLoadAvgCPUUtilizationOnly(
    $serverId: ID!
    $startTs: Int!
    $endTs: Int!
  ) {
    getSystemStats(serverId: $serverId, startTs: $startTs, endTs: $endTs) {
      id
      cpuUtilization
    }
  }
`;

/**
 * __useCpuAndLoadAvgCpuUtilizationOnlyQuery__
 *
 * To run a query within a React component, call `useCpuAndLoadAvgCpuUtilizationOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpuAndLoadAvgCpuUtilizationOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpuAndLoadAvgCpuUtilizationOnlyQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useCpuAndLoadAvgCpuUtilizationOnlyQuery(
  baseOptions: Apollo.QueryHookOptions<
    CpuAndLoadAvgCpuUtilizationOnlyQuery,
    CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
  > &
    (
      | {
          variables: CpuAndLoadAvgCpuUtilizationOnlyQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CpuAndLoadAvgCpuUtilizationOnlyQuery,
    CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
  >(CpuAndLoadAvgCpuUtilizationOnlyDocument, options);
}
export function useCpuAndLoadAvgCpuUtilizationOnlyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CpuAndLoadAvgCpuUtilizationOnlyQuery,
    CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CpuAndLoadAvgCpuUtilizationOnlyQuery,
    CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
  >(CpuAndLoadAvgCpuUtilizationOnlyDocument, options);
}
// @ts-ignore
export function useCpuAndLoadAvgCpuUtilizationOnlySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CpuAndLoadAvgCpuUtilizationOnlyQuery,
    CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CpuAndLoadAvgCpuUtilizationOnlyQuery,
  CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
>;
export function useCpuAndLoadAvgCpuUtilizationOnlySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CpuAndLoadAvgCpuUtilizationOnlyQuery,
        CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CpuAndLoadAvgCpuUtilizationOnlyQuery | undefined,
  CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
>;
export function useCpuAndLoadAvgCpuUtilizationOnlySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CpuAndLoadAvgCpuUtilizationOnlyQuery,
        CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CpuAndLoadAvgCpuUtilizationOnlyQuery,
    CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
  >(CpuAndLoadAvgCpuUtilizationOnlyDocument, options);
}
export type CpuAndLoadAvgCpuUtilizationOnlyQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgCpuUtilizationOnlyQuery
>;
export type CpuAndLoadAvgCpuUtilizationOnlyLazyQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgCpuUtilizationOnlyLazyQuery
>;
export type CpuAndLoadAvgCpuUtilizationOnlySuspenseQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgCpuUtilizationOnlySuspenseQuery
>;
export type CpuAndLoadAvgCpuUtilizationOnlyQueryResult = Apollo.QueryResult<
  CpuAndLoadAvgCpuUtilizationOnlyQuery,
  CpuAndLoadAvgCpuUtilizationOnlyQueryVariables
>;
export const CpuAndLoadAvgLoadAvgOnlyDocument = gql`
  query CPUAndLoadAvgLoadAvgOnly($serverId: ID!, $startTs: Int!, $endTs: Int!) {
    getSystemStats(serverId: $serverId, startTs: $startTs, endTs: $endTs) {
      id
      loadAvg1min
      loadAvg5min
      loadAvg15min
    }
  }
`;

/**
 * __useCpuAndLoadAvgLoadAvgOnlyQuery__
 *
 * To run a query within a React component, call `useCpuAndLoadAvgLoadAvgOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpuAndLoadAvgLoadAvgOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpuAndLoadAvgLoadAvgOnlyQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useCpuAndLoadAvgLoadAvgOnlyQuery(
  baseOptions: Apollo.QueryHookOptions<
    CpuAndLoadAvgLoadAvgOnlyQuery,
    CpuAndLoadAvgLoadAvgOnlyQueryVariables
  > &
    (
      | { variables: CpuAndLoadAvgLoadAvgOnlyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CpuAndLoadAvgLoadAvgOnlyQuery,
    CpuAndLoadAvgLoadAvgOnlyQueryVariables
  >(CpuAndLoadAvgLoadAvgOnlyDocument, options);
}
export function useCpuAndLoadAvgLoadAvgOnlyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CpuAndLoadAvgLoadAvgOnlyQuery,
    CpuAndLoadAvgLoadAvgOnlyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CpuAndLoadAvgLoadAvgOnlyQuery,
    CpuAndLoadAvgLoadAvgOnlyQueryVariables
  >(CpuAndLoadAvgLoadAvgOnlyDocument, options);
}
// @ts-ignore
export function useCpuAndLoadAvgLoadAvgOnlySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CpuAndLoadAvgLoadAvgOnlyQuery,
    CpuAndLoadAvgLoadAvgOnlyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CpuAndLoadAvgLoadAvgOnlyQuery,
  CpuAndLoadAvgLoadAvgOnlyQueryVariables
>;
export function useCpuAndLoadAvgLoadAvgOnlySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CpuAndLoadAvgLoadAvgOnlyQuery,
        CpuAndLoadAvgLoadAvgOnlyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CpuAndLoadAvgLoadAvgOnlyQuery | undefined,
  CpuAndLoadAvgLoadAvgOnlyQueryVariables
>;
export function useCpuAndLoadAvgLoadAvgOnlySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CpuAndLoadAvgLoadAvgOnlyQuery,
        CpuAndLoadAvgLoadAvgOnlyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CpuAndLoadAvgLoadAvgOnlyQuery,
    CpuAndLoadAvgLoadAvgOnlyQueryVariables
  >(CpuAndLoadAvgLoadAvgOnlyDocument, options);
}
export type CpuAndLoadAvgLoadAvgOnlyQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgLoadAvgOnlyQuery
>;
export type CpuAndLoadAvgLoadAvgOnlyLazyQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgLoadAvgOnlyLazyQuery
>;
export type CpuAndLoadAvgLoadAvgOnlySuspenseQueryHookResult = ReturnType<
  typeof useCpuAndLoadAvgLoadAvgOnlySuspenseQuery
>;
export type CpuAndLoadAvgLoadAvgOnlyQueryResult = Apollo.QueryResult<
  CpuAndLoadAvgLoadAvgOnlyQuery,
  CpuAndLoadAvgLoadAvgOnlyQueryVariables
>;
